import { SharedUiFeature } from '@soff/shared-ui';
import { SOFF_VIEW_FILTER_CONTEXT, SoffViewFilterContext } from './view-filter-context.model';

/**
 * Current user + share targets for saved views, for `provideSharedUi(config, withSavedViews(...))`.
 * The factory runs in an injection context.
 */
export function withSavedViews(context: () => SoffViewFilterContext): SharedUiFeature {
  return { kind: 'savedViews', providers: [{ provide: SOFF_VIEW_FILTER_CONTEXT, useFactory: context }] };
}
